import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { VendorRolesState } from "../../models/vendor-admin/vendor-roles.state";

const initialState: VendorRolesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(VendorAdminActions.vendorRoles.getApi, (state) => ({ ...state, loading: true })),
	on(VendorAdminActions.vendorRoles.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type"),
		loading: false
	})),
	on(VendorAdminActions.vendorRoles.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function getVendorRolesReducer(
	state: VendorRolesState | undefined,
	action: Action
): VendorRolesState {
	return reducer(state, action);
}
